import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { UpdateGlobalSourceDialogResultModel } from '../../models/update-global-source-dialog.model';

export enum UpdateGlobalSourceOptions {
    updateAll= 'UPDATE_ALL',
    updatePartial= 'UPDATE_PARTIAL'
}

@Component({
    selector: 'agpr-update-global-source-dialog',
    templateUrl: './update-global-source-dialog.component.html',
    styleUrls: ['./update-global-source-dialog.component.scss'],
    standalone: false
})
export class UpdateGlobalSourceDialogComponent extends AbstractDialogComponent implements OnInit {

    readonly buttonTypes = ButtonTypesEnum;

    @Input() public id: string;
    @Input() alertMessage: string;
    @Input() alertType: messageSeverityEnum;
    @Input() message: string;
    @Input() allAlertMessageList: string[];
    @Input() defaultAlertMessageList: string[];

    alertMessageList: string[];

    updateGlobalSourceOptions = UpdateGlobalSourceOptions;
    selectedOption: UpdateGlobalSourceOptions = UpdateGlobalSourceOptions.updateAll;

    @Input() confirmAction: () => Observable<any>;

    loading: boolean = false;

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'UpdateGlobalSource');
        this.alertType = messageSeverityEnum.info;
    }

    ngOnInit(): void {
        this.showAlertList();
    }

    showAlertList() {
        if (this.selectedOption === this.updateGlobalSourceOptions.updatePartial) {
            this.alertMessageList = this.defaultAlertMessageList;
        } else {
            this.alertMessageList = this.allAlertMessageList;
        }
    }

    /**
     * Action when the user clicks the "OK" button
     */
    ok(): void {
        if (this.confirmAction) {
            this.loading = true;
            this.confirmAction().subscribe({
                next: () => this.closeDialog(),
                error: () => this.loading = false
            });
            return;
        }
        const result: UpdateGlobalSourceDialogResultModel = {confirmed: true, selectedOption: this.selectedOption};
        this.closeDialog(result);
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        const result: UpdateGlobalSourceDialogResultModel = {confirmed: false, selectedOption: this.selectedOption};
        this.closeDialog(result);
    }
}
